import Vue from 'vue';
import { Base64 } from 'js-base64';
import { Project } from '@/shared/project.model';

const API_HOST = process.env.VUE_APP_BASE_API;

export function getProjectInfo(): Promise<Project> {
    return new Promise((resolve, reject) => {
        Vue.axios.get(API_HOST).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.log('Load base config failed: ', err);
            reject(err);
        });
    });
}

export function getArticles(catalogId: number, page?: number, size?: number): Promise<{data: Array<Article>;count: string}> {
    const nullUndefined = [null,undefined]
    return new Promise((resolve, reject) => {
        const url = `${API_HOST}/catalogs/${catalogId}/articles?sort=sortOrder,desc${nullUndefined.findIndex(x => x === page) < 0 ? '&page=' + page : ''}${nullUndefined.findIndex(x => x === size) < 0?'&size='+size:''}`;
        Vue.axios.get(url).then(res => {
            resolve({
                data: res.data as Array<Article>, count: res.headers['x-total-count']});
        }).catch(err => {
            console.log('Get articles failed: ', err);
            reject(err);
        });
    });
}

export function getArticle(articleId: number): Promise<Article> {
    return new Promise((resolve, reject) => {
        const url = `${API_HOST}/articles/${articleId}`;
        Vue.axios.get(url).then(res => {
            resolve(res.data as Article);
        }).catch(err => {
            console.log('Get an article failed: ', err);
            reject(err);
        });
    });
}

export function articleSearch(catalogId: string|number, keywords: string): Promise<Array<Article>> {
    const url = `${API_HOST}/articles/search`
    return Vue.axios.post(url, {catalogId, keywords}).then(res => res.data)
}

export function getJsConfig(url: string): Promise<unknown> {
    return new Promise((resolve, reject) => {
        const burl = Base64.encodeURI(url);
        const params = { burl }
        Vue.axios.get(`${API_HOST}/js-skd-config`, { params }).then(res => {
            resolve(res.data);
        }).catch(err => {
            console.log('Get js-sdk config failed: ', err);
            reject(err);
        });
    });
}
